import React from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import useMediaQuery from "@mui/material/useMediaQuery";
import { userLogout } from "../../../../services/api/authApis";
import { NavLink, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { clearAuth } from "../../../../redux/reducers/authSlice";
import { setClearAllDataExceptCategory, setClearAllOrderData, setClearOrder } from "../../../../redux/reducers/createOrderSlice";
export default function BasicMenu() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);
  const isMobileNav = useMediaQuery("(max-width:991px)");
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const desktopMenuOpen = Boolean(anchorEl);
  const handleClick = (event) => {
    if (isMobileNav) {
      setMobileMenuOpen((prev) => !prev);
      return;
    }
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setMobileMenuOpen(false);
  };
  const logoutHandler = () => {
    userLogout();
    dispatch(clearAuth());
    dispatch(setClearOrder())
    dispatch(setClearAllOrderData())
    dispatch(setClearAllDataExceptCategory())
    navigate("/");
  };
  const gotoOrderCrearte = (serviceType) => {
    navigate('/formpostal', { state: { serviceType: serviceType } })

  }
  return (
    <>
      <div className="dashboard-header-wrap d-flex align-items-center">
        <div className="profile-name-wrap d-flex align-items-center">
          <div className="profile-img">
            <img src="/assets/images/profile-img.png" alt="" />
          </div>
          <p className="m-0">{user?.name}</p>
        </div>
        <div className="menu-icon-wrap">
          <Button
            id="basic-button"
            aria-controls={desktopMenuOpen ? "basic-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={isMobileNav ? (mobileMenuOpen ? "true" : "false") : (desktopMenuOpen ? "true" : "false")}
            onClick={handleClick}
          >
            {/* <FontAwesomeIcon icon={icon({ name: "fa-bars" })} /> */}
            <FontAwesomeIcon icon={faBars} />
          </Button>
          {!isMobileNav && (
            <Menu
              id="basic-menu"
              className="user-header-popper"
              anchorEl={anchorEl}
              open={desktopMenuOpen}
              onClose={handleClose}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
            >
              <MenuItem className={window.location.pathname === '/dashboard' && 'colour-red'} onClick={() => { navigate("/dashboard"); handleClose() }}>
                Dashboard
              </MenuItem>
              <MenuItem className={window.location.pathname === '/booking' && 'colour-red'} onClick={() => { navigate("/booking"); handleClose() }}>
                My Bookings
              </MenuItem>
              <MenuItem className={window.location.pathname === '/my-orders' && 'colour-red'} onClick={() => { navigate("/my-orders"); handleClose() }}>
                My Orders
              </MenuItem>

              <MenuItem className={window.location.pathname === '/my-profile' && 'colour-red'} onClick={() => { navigate("/my-profile"); handleClose() }}>
                My Profile
              </MenuItem>
              {/* <MenuItem>My account</MenuItem> */}
              <MenuItem onClick={() => logoutHandler()}>Logout</MenuItem>
              {/* <MenuItem onClick={handleClose}>Profile</MenuItem>
        <MenuItem onClick={handleClose}>My account</MenuItem>
        <MenuItem onClick={handleClose}>Logout</MenuItem> */}
            </Menu>
          )}
        </div>
      </div>
      {isMobileNav && mobileMenuOpen && <div className="mobile-menu-bar">
        <div className="d-flex mobile-profile">
          <NavLink to="/">
            {" "}
            <img src="/assets/images/profile-img.png" alt="" />{" "}
          </NavLink>
          <div className="mobile-profile-name">
            <h3>{user?.name}</h3>
            <p>{user?.email} </p>
          </div>
        </div>
        <ul className="cleaning-1">
          <li onClick={() => { gotoOrderCrearte("order-booking"); handleClose() }}>
            <img src="/assets/images/clean-2.png" alt="" />
            General/Regular Cleaning
          </li>
          <li onClick={() => { gotoOrderCrearte('professional'); handleClose() }}>
            <img src="/assets/images/Clean1.png" alt="" />
            Professional Cleaning
          </li>
        </ul>

        <ul className="menu-list-for-mobile">
          <li className={window.location.pathname === '/dashboard' && 'colour-red'} onClick={() => { handleClose(); navigate("/dashboard") }}>Dashboard</li>
          <li className={window.location.pathname === '/booking' && 'colour-red'} onClick={() => { handleClose(); navigate("/booking") }}>My Bookings</li>
          <li className={window.location.pathname === '/my-orders' && 'colour-red'} onClick={() => { handleClose(); navigate("/my-orders") }}>My Orders</li>

          <li className={window.location.pathname === '/my-profile' && 'colour-red'} onClick={() => { handleClose(); navigate("/my-profile") }}>My Profile</li>
          {/* <MenuItem>My account</MenuItem> */}
          <li onClick={() => { logoutHandler(); handleClose() }}>Logout</li>
        </ul>
      </div>}

    </>
  );
}
